/* dwl-set-story.js — slimme laag op de setpagina.
   1. Kijkt wat er al in de winkelwagen zit: eenden uit deze set krijgen een vinkje,
      en wie er al een paar heeft krijgt het eerlijke advies om de rest los te nemen.
   2. De knop onderaan voegt de set toe via dwl-smart-upsell ([data-dsu-add]) en
      opent daarna de winkelwagen. */
(function () {
  var box = document.querySelector('[data-dss2]');
  if (!box) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function mark(cart) {
    if (!cart || !cart.items) return;
    var inCart = {};
    cart.items.forEach(function (l) { inCart[l.variant_id] = true; });
    var n = 0;
    box.querySelectorAll('[data-dss2-variant]').forEach(function (card) {
      var has = !!inCart[card.getAttribute('data-dss2-variant')];
      card.classList.toggle('is-have', has);
      var tag = card.querySelector('.dss2-card__have');
      if (tag) tag.hidden = !has;
      if (has) n++;
    });
    var smart = box.querySelector('[data-dss2-smart]');
    if (smart) {
      if (n > 0 && n < 7) {
        smart.textContent = smart.getAttribute('data-text').replace('[n]', n);
        smart.hidden = false;
      } else {
        smart.hidden = true;
      }
    }
  }

  function load() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(mark)
      .catch(function () {});
  }
  load();
  document.addEventListener('dwl:cart-updated', function (e) { mark(e.detail); });

  var btn = box.querySelector('[data-dss2-add]');
  if (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-dss2-add'), 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          /* winkelwagen verversen én openen (cart-bundle.js) */
          if (window.DWLCart && typeof window.DWLCart.refreshCartUI === 'function') {
            return Promise.resolve(window.DWLCart.refreshCartUI(true)).then(function () {
              var d = document.querySelector('cart-drawer');
              if (d && !d.classList.contains('active') && typeof window.DWLCart.openDrawer === 'function') window.DWLCart.openDrawer();
              load();
            });
          }
          window.location.href = root + 'cart';
        })
        .catch(function () { window.location.href = root + 'cart'; })
        .then(function () { btn.disabled = false; });
    });
  }
})();
